import cn from "classnames"

import { IconTag } from "@/molecules/IconTag"

import styles from "./StatusTag.module.scss"

import type { StatusTagComponent } from "."

export const StatusTag: StatusTagComponent = ({
  status,
  textCapitalizeUnset,
  ...props
}) => {
  const className = cn(
    { [styles.success]: status === "success" },
    { [styles.failed]: status === "failed" },
    { [styles.pending]: status === "pending" },
    { [styles.warning]: status === "warning" },
    { [styles.neutral]: status === "neutral" },
    { [styles.textCapitalizeUnset]: textCapitalizeUnset }
  )

  return (
    <IconTag
      iconSize="sm"
      data-status-tag={status}
      classes={{ tag: className }}
      {...props}
    />
  )
}
